// Hook para manejar los KPIs de productos
// Hook for managing products KPIs

import { useQuery } from '@tanstack/react-query';
import { useToast } from '@shared/hooks/use-toast';
import { ProductsKpisApiAdapter, ProductsKpisParams } from '../adapters/ProductsKpisApiAdapter';
import { apiClientWH } from '@shared/services/ApiClient';
import { useDashboardFilters } from './useDashboardFilters';

export const useProductsKpis = (params: ProductsKpisParams = {}) => {
  const { toast } = useToast();
  const { setRefreshingComplete } = useDashboardFilters();
  const productsKpisAdapter = new ProductsKpisApiAdapter(apiClientWH);

  const {
    data: productsKpisResponse,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery({
    queryKey: ['productsKpis', params],
    queryFn: () => productsKpisAdapter.getProductsKpis(params),
    staleTime: 1 * 60 * 1000, // 1 minuto
    gcTime: 5 * 60 * 1000, // 5 minutos
    onSuccess: () => {
      setRefreshingComplete();
    },
    onError: (error: any) => {
      setRefreshingComplete();
      toast({
        title: 'Error al cargar métricas de productos',
        description: error?.message || 'Error inesperado. Inténtalo de nuevo.',
        variant: 'destructive',
      });
    },
  });

  return {
    productsKpis: productsKpisResponse?.data || {
      product_list: [],
      product_sum: 0,
      product_count: 0,
    },
    isLoading,
    isFetching,
    error: error?.message || null,
    refetch,
  };
};
